import { Tab, Tabs, styled } from "@mui/material";

export const UnderlineTabs = styled(Tabs)(({ theme }) => ({
  width: "100%",
  minHeight: 40,
  flexShrink: 0,
  border: "none",
  boxShadow: "none",
  backgroundColor: "transparent",
  "& .MuiTabs-scroller": {
    border: "none",
  },
  "& .MuiTabs-flexContainer": {
    border: "none",
  },
  "& .MuiTab-root": {
    border: "none",
    boxShadow: "none",
    borderRadius: 0,
  },
  "& .MuiTabs-indicator": {
    height: 3,
    bottom: 0,
    borderRadius: "3px 3px 0 0",
    backgroundColor: theme.palette.primary800.main,
  },
}));

export const UnderlineTab = styled(Tab)(({ theme }) => ({
  minHeight: 40,
  paddingTop: theme.spacing(0.75),
  paddingBottom: theme.spacing(0.75),
  textTransform: "none",
  fontWeight: 600,
  color: theme.palette.text.secondary,
  transition: "color .2s ease",
  "& .MuiTab-iconWrapper": {
    marginRight: theme.spacing(1),
  },
  "&:hover": {
    color: theme.palette.primary800.main,
  },
  "&.Mui-selected": {
    color: theme.palette.primary800.main,
  },
}));
